import { Reveal } from "@/components/site/Reveal";
import { SERVICES } from "@/lib/data";
import { Plus } from "lucide-react";

export default function Services() {
  return (
    <section id="services" className="relative py-28 lg:py-36 bg-blush-pale/40 grain" data-testid="services">
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal className="max-w-2xl">
          <p className="font-sans text-xs tracking-[0.3em] uppercase text-blush-dusty mb-4">What we care for</p>
          <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl text-olive-deep leading-[1.05]">
            Comprehensive women's health, <span className="italic text-blush-dusty">under one gentle roof.</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-olive-sage/15 rounded-3xl overflow-hidden border border-olive-sage/15">
          {SERVICES.map((s, i) => (
            <Reveal key={s.title} delay={(i % 3) * 0.06}>
              <div className="group h-full bg-cream hover:bg-white p-8 transition-colors duration-400" data-testid={`service-${i}`}>
                <div className="flex items-start justify-between gap-4">
                  <h3 className="font-serif text-2xl text-olive-deep leading-tight">{s.title}</h3>
                  <Plus className="w-5 h-5 text-blush-dusty shrink-0 group-hover:rotate-90 transition-transform duration-300" />
                </div>
                <p className="font-sans text-sm text-olive-sage mt-3 leading-relaxed">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
